<template>
  <div id="chart" >
    <apexchart ref="my_apexchart" :options="chartOptions" :series="[ltm_data]"></apexchart>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    ltm_data: Object,
    ltm_label: Array,
    color: String,
  },
  data() {
    return {
      chart_tab: null,
      my_apexchart: null,
      chartOptions: {
        chart: {
          type: 'line',
          zoom: {
            enabled: false
          },
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: 2,
          curve: 'smooth',
        },
        colors: [this.color],
        legend: {
          tooltipHoverFormatter: function(val, opts) {
            return val + ' - <strong>' + opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] + '</strong>'
          }
        },
        markers: {
          size: 0,
          hover: {
            sizeOffset: 4
          }
        },
        xaxis: {
          categories: this.ltm_label
          // ["Jun, 2023", "Jul, 2023", "Aug, 2023", "Sep, 2023", "Oct, 2023", "Nov, 2023", "Dec, 2023", "Jan, 2024", "Feb, 2024", "Mar, 2024", "Apr, 2024", "May, 2024"],
        },
        noData: {  
          text: this.isDataBeingFetched() ? "Loading...":"No Data present in the graph!",  
          align: 'center',  
          verticalAlign: 'middle',  
          offsetX: 0,  
          offsetY: 0,  
          style: {  
            color: "#000000",  
            fontSize: '14px',  
            fontFamily: "Helvetica"  
          }  
        },
        tooltip: {
          // y: [
          //   {
          //     title: {
          //       formatter: function (val) {
          //         return val + " (mins)"
          //       }
          //     }
          //   },
          //   {
          //     title: {
          //       formatter: function (val) {
          //         return val + " per session"
          //       }
          //     }
          //   },
          //   {
          //     title: {
          //       formatter: function (val) {
          //         return val;
          //       }
          //     }
          //   }
          // ]
        },
        grid: {
          borderColor: '#f1f1f1',
        }
      },
    };
  },
  methods: {
    isDataBeingFetched() {
      return Object.keys(this.ltm_data).length <= 1
    }
  }
};

</script>
